const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgPaySupplier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2V14.5M14.5 4H10.75C10.2859 4 9.70104 4.30666 9.51256 4.5C9.32408 4.69334 9 5 9 6C9 7 9.18437 7.15925 9.51256 7.48744C9.84075 7.81563 10.2859 8 10.75 8H13.25C13.7141 8 14.2785 8.30358 14.4874 8.51256C14.6964 8.72155 15 9.5 15 10C15 10.5 15 11 14.4874 11.4874C13.9749 11.9749 13.7141 12 13.25 12H9M3 15.9999C4.49999 14.4999 4.5 14.4999 5.5 14.4999L12.5 14.4999C13.5 14.4999 13.7008 16.0323 13.7008 16.0323M13.7008 16.0323C13.7008 16.0323 17.5878 12.8418 19 12C19.6776 11.7154 20.9881 12.4026 21 13.4999C21 13.4999 14.5 20 13 20C13 20 7.5 20 6.98056 20.0194C6.46113 20.0389 6 21 6 21M13.7008 16.0323C13.7008 17.0323 12.6248 17.3869 12.1248 17.3868H7.6248",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaySupplier);
export default __webpack_public_path__ + "static/media/pay-supplier.3def06d80c335c8438bec965a64fc266.svg";
export { ForwardRef as ReactComponent };